import React, { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Booking from "@/pages/Booking";
import Partner from "@/pages/Partner";
import Legal from "@/pages/Legal";
import Join from "@/pages/Join";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import Job from "@/pages/Job";
import Rate from "@/pages/Rate";
import Pay from "@/pages/Pay";
import ChelaApp from "@/pages/ChelaApp";
import Track from "@/pages/Track";
import Travel from "@/pages/Travel";
import InstallBanner from "@/components/InstallBanner";
import Jingle from "@/components/Jingle";

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/partner" element={<Partner />} />
          <Route path="/join" element={<Join />} />
          <Route path="/terms" element={<Legal />} />
          <Route path="/privacy" element={<Legal />} />
          <Route path="/safety" element={<Legal />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/job/:token" element={<Job />} />
          <Route path="/rate/:token" element={<Rate />} />
          <Route path="/pay/:token" element={<Pay />} />
          <Route path="/chela" element={<ChelaApp />} />
          <Route path="/track/:token" element={<Track />} />
          <Route path="/travel/:token" element={<Travel />} />
        </Routes>
        <Jingle />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
      <InstallBanner />
    </LanguageProvider>
  );
}

export default App;
